import * as RmActions from '../../radioactive-materials.actions';
import * as RmActionsWaste from '../rm-waste.actions';
import * as RmTestActions from '../../rm-test/rm-test.actions';
import { generateQRCode } from '../../../../common/utils/util.qrcode';
import isNull from 'lodash/isNull';
import get from 'lodash/get';

/**
 * @const {object}
 * @memberOf module:RadioactiveMaterials
 */
export const rmWasteDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $scope, $rootScope, FileActions, Notifier) {
        const RM_WASTE = 'rmWaste';
        const unsubscribe = $ngRedux.connect(({ radioactiveMaterials }) => ({
            rmWaste: radioactiveMaterials.rmWaste
        }), {
            ...FileActions,
            ...RmActions,
            ...RmActionsWaste,
            ...RmTestActions
        })(this);

        /**
         * @function $onInit
         */
        this.$onInit = () => {
            if (this.rmWaste.id) {
                this.identifier = 'app.radioactiveMaterials.waste.manage';
                this.state = 'app.radioactiveMaterials.waste.manage.details';
                this.getAtomicNums(RM_WASTE, this.rmWaste.isotope);
                generateQRCode('qrcode', {
                    type: RM_WASTE,
                    id: this.rmWaste.id,
                    visualId: this.rmWaste.visualId,
                });
            }
            else {
                this.identifier = 'app.radioactiveMaterials.waste.add';
                this.state = 'app.radioactiveMaterials.waste.add.details';
                this.getNextId(RM_WASTE).then((id) => {
                    generateQRCode('qrcode', {
                        type: RM_WASTE,
                        visualId: id,
                    });
                });
            }

            this.getWasteTypes();
            this.getIsotopes(RM_WASTE);
            this.getWasteDisposalReach();
            this.getTestDisposalCompanies('rmWaste');
            initUnits();
        }

        const initUnits = () => {
            this.getUnits(RM_WASTE, this.rmWaste.closureUnitType, 'dosabs', 'closureUnits');
            this.getUnits(RM_WASTE, this.rmWaste.closureUnitType, 'radact', 'disposalUnits');
            this.getUnits(RM_WASTE, this.rmWaste.closureUnitType, 'distnc', 'distanceFromSurfaceUnits');
        };

        this.onIsotope = ({ input }) => {
            this.getAtomicNums(RM_WASTE, input, true);
        };

        this.onAtomicNum = ({ item }) => {
            this.setHalfLife(RM_WASTE, 'halfLife', item.halfLife);
        };

        this.onClosureUnit = ({ input }) => {
            this.getUnits(RM_WASTE, input, 'dosabs', 'closureUnits', { closureUnit: null });
            this.getUnits(RM_WASTE, input, 'radact', 'disposalUnits', { disposalUnit: null });
            this.getUnits(RM_WASTE, input, 'distnc', 'distanceFromSurfaceUnits', { distanceFromSurfaceUnit: null });
        };

        this.estimateDisposalReach = () => {
            const {
                atomicNum,
                dateOfClosure,
                dateOfClosureDose,
                closureUnit,
                disposalToReach
            } = this.rmWaste;

            const dose = dateOfClosureDose && dateOfClosureDose !== '';
            if (disposalToReach > dateOfClosureDose && dose && disposalToReach) {
                Notifier.error('"Disposal to Reach" cant be higher than "Dose Measurement @ Date of Closure"');
            } else {
                if (atomicNum && dateOfClosure && dose && closureUnit && disposalToReach) {
                    this.getWasteDisposalReachEstimate({
                        ato_id: parseInt(atomicNum),
                        date_of_closure: dateOfClosure,
                        dose_measurement_closure: parseFloat(dateOfClosureDose),
                        unit_id: parseInt(closureUnit),
                        disposal_to_reach: parseFloat(disposalToReach)
                    });
                }
            }
        };


        this.saveDetails = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.rmWasteForm');
            if (this.rmWasteForm.$valid) {
                this.saveWaste(this.rmWaste).then(() => {
                    Notifier.success('New radioactive material waste has been successfully saved');
                    isNull(this.rmWaste.id) && resetForm();
                }).catch(() => {
                    Notifier.error('System Error!');
                });
            } else {
                    Notifier.error('Please fill in the form fields');
            }
        }

        const resetForm = () => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', '$ctrl.rmWasteForm');
            this.rmWasteForm.$setPristine();
            this.rmWasteForm.$setUntouched();
            this.getNextId(RM_WASTE).then((id) => {
                this.qrCodeGenerate(RM_WASTE, this.rmWaste);
            });
            initUnits();
        };

        this.onPrintQRcode = () => {
            this.qrCodePrint(RM_WASTE, this.rmWaste);
        };

        this.onSaveImage = async (event) => {
            const { filePath, width, height } = event[0];
            return await this.saveImage(filePath, width, height);
        };

        this.saveCompany = () => {
            if (validateCompany()) {
                this.saveDisposalCompany({
                    dsc_id: get(this.rmWaste.disposalCompany, 'id'),
                    name: this.rmWaste.disposalCompanyName,
                    address: this.rmWaste.disposalCompanyAddress,
                    email: this.rmWaste.disposalCompanyEmail,
                    phone: this.rmWaste.disposalCompanyPhone,
                }).then(() => {
                    Notifier.success('Disposal Company changes has been successfully saved');
                    this.getTestDisposalCompanies('rmWaste');
                }).catch(() => {
                    Notifier.error('System Error!');
                });
            } else {
                Notifier.error('Please fill in the form fields (Disposal Company Name, Address, Email)');
            }
        };

        const validateCompany = () => {
            let valid = true;
            const { disposalCompanyName, disposalCompanyAddress, disposalCompanyEmail } = this.rmWaste;
            if (!disposalCompanyName || disposalCompanyName.trim() === '') {
                valid = false;
            }
            if (!disposalCompanyAddress || disposalCompanyAddress.trim() === '') {
                valid = false;
            }
            if (!disposalCompanyEmail || disposalCompanyEmail.trim() === '') {
                valid = false;
            }
            return valid;
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
        }
    },
    template: require('./rm-waste-details.html')
};
